import { TableHeader, TableHeaderCell } from '@hivewatch/dark'

import { WorkflowsColumnIProps } from '../types/types'

export const WorkflowsTableHeader = ({
  columns,
}: {
  columns: WorkflowsColumnIProps[]
}) => {
  return (
    <TableHeader>
      {columns.map((col) => (
        <TableHeaderCell column={col.sortColumn} key={col.key} {...col.style}>
          {col.header}
        </TableHeaderCell>
      ))}
    </TableHeader>
  )
}
